<template>
<div id="RequestDetail" class="">
  <b-container fluid>
    <b-row>
      <!-- <b-col md="4" class="text-white bg-dark">2 of 2</b-col> -->
      <b-col  lg="10" class="form-login mx-auto mb-3">
        <div v-if="!dataReady">
          <b-spinner style="width: 3rem; height: 3rem;" label="Loading..." variant="info"></b-spinner>
        </div>
        <b-card :border-variant="isUpdate ? 'warning' : 'info'" class="mb-1 animate__animated animate__fadeInDown" footer-class="text-center" v-if="dataReady">
          <b-card-body class="text-left pb-0">
            <b-row>
              <b-col>
                <h2 class="mb-2">ขอรับสิทธิ์ส่วนลดค่าธรรมเนียมการศึกษา</h2>
                <h3>ตามประกาศรัฐบาลเพื่อช่วยเหลือสถานการณ์โควิด</h3>
              </b-col>
            </b-row>
          </b-card-body>
          <b-card-body>
            <b-form @submit="onSubmit">
              <b-card-text class="text-left">
                &emsp;ด้วยการยืนยันตัวตนผ่านระบบอิเล็กทรอนิกส์ที่มหาวิทยาลัยธรรมศาสตร์จัดทำขึ้น ข้าพเจ้าขอรับรองว่าข้าพเจ้าเป็นผู้กระทำการยืนยันตัวตนและยืนยันสิทธินี้ด้วยตัวข้าพเจ้าเอง
                <!-- <br>
                <br>
                &emsp; -->
                โดยข้าพเจ้าขอแสดงความประสงค์ ดังนี้
              </b-card-text>
              <b-card-text class="text-left ml-4">
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio v-model="confirmRequest" class="mb-3"
                    :aria-describedby="ariaDescribedby" 
                    name="confirm-radios" value="1">
                    ข้าพเจ้า <b class="text-success" style=" font-size: 1.2rem; ">ขอยืนยันสิทธิรับส่วนลดค่าเล่าเรียนและค่าธรรมเนียมการศึกษา</b> สถาบันอุดมศึกษาของรัฐ ตามมาตรการลดภาระค่าใช้จ่ายด้านการศึกษาของนิสิตนักศึกษาในสถาบันอุดมศึกษาภาครัฐและเอกชน ของกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมในภาคเรียนที่ 1/2564 ตามมติคณะรัฐมนตรี และในการนี้ข้าพเจ้ายินยอมให้มหาวิทยาลัย/สถาบันรับเงินที่ภาครัฐสนับสนุน แทนข้าพเจ้าในส่วนที่ข้าพเจ้าพึงได้รับ และออกหลักฐานการรับเงินเพื่อเป็นหลักฐานแก่สำนักบริหารหนี้สาธารณะในนามข้าพเจ้าและสำหรับการตรวจสอบจากหน่วยงานที่เกี่ยวข้องต่อไป
                  </b-form-radio>
                  <br><br>
                  <b-form-radio v-model="confirmRequest" class="mb-3"
                    :aria-describedby="ariaDescribedby" 
                    name="confirm-radios" value="2">
                    ข้าพเจ้า <b class="text-danger" style=" font-size: 1.2rem; ">ไม่ขอรับส่วนลดค่าเล่าเรียนและค่าธรรมเนียมการศึกษา</b> สถาบันอุดมศึกษาของรัฐของกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมในภาคเรียนที่ 1/2564 โดยขอรับเพียงการช่วยเหลือในส่วนของมหาวิทยาลัย
                  </b-form-radio>
                </b-form-group>
              </b-card-text>
              <hr>
              <b-card-text class="text-left">
                <b-row>
                  <!-- <b-col cols="12">
                    <p>&emsp;ข้าพเจ้า  {{form.prefix_th}}{{form.displayname_th}} เลขทะเบียน {{form.username}}</p>
                  </b-col> -->
                  <!-- <b-col md="4">
                    <div class="form-label-group">
                      <b-form-input placeholder="placeholder" id="form_idcard" readonly autocomplete="off" class="mb-2" v-model="form.id_card" type="tel" required></b-form-input>
                      <label for="form_idcard" class="mb-1">รหัสบัตรประชาชน <span style="color:red">*</span></label>
                      <b-form-text id="input-live-help">หากข้อมูลไม่ถูกต้องกรุณาติดต่อฝ่ายทะเบียน</b-form-text>
                    </div>
                  </b-col> -->
                  <b-col md="4">
                    <div class="form-label-group">
                      <b-form-input placeholder="placeholder" id="form_stdname" readonly autocomplete="off" class="mb-2" v-model="form.displayname_th" type="text" required></b-form-input>
                      <label for="form_stdname" class="mb-1">ชื่อ-นามสกุล</label>
                      <b-form-text id="input-live-help">หากข้อมูลไม่ถูกต้องกรุณาติดต่อสำนักทะเบียนนักศึกษา</b-form-text>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-label-group">
                      <b-form-input placeholder="placeholder" id="form_idstd" readonly autocomplete="off" class="mb-2" v-model="form.username" type="tel" required></b-form-input>
                      <label for="form_idstd" class="mb-1">เลขทะเบียน</label>
                      <!-- <b-form-text id="input-live-help">หากข้อมูลไม่ถูกต้องกรุณาติดต่อฝ่ายทะเบียน</b-form-text> -->
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-label-group">
                      <b-form-input placeholder="placeholder" id="form_tel" autocomplete="off" class="mb-2" v-model="form.telephone" type="tel" maxlength="10" 
                        :state="telState"
                        aria-describedby="input-live-feedback"
                        required></b-form-input>
                      <label for="form_tel" class="mb-1">เบอร์โทรติดต่อ <span style="color:red">*</span></label>
                      <b-form-invalid-feedback id="input-live-feedback">
                        กรุณากรอกเบอร์โทรศัพท์ให้ครบ
                      </b-form-invalid-feedback>
                    </div>
                  </b-col>
                </b-row>
              </b-card-text>
              <b-card-text>
                <b-form-checkbox
                  id="checkaccept"
                  v-model="accept"
                  name="checaccept"
                >
                  ข้าพเจ้ายินยอมให้มหาวิทยาลัยธรรมศาสตร์ส่งข้อมูลส่วนบุคคลที่จำเป็นของข้าพเจ้า ให้กับหน่วยงานที่เกี่ยวข้องเพื่อขอรับสิทธิ์นี้
                </b-form-checkbox>
              </b-card-text>
              <b-card-text>
                <b-button variant="secondary" :disabled="!accept" type="submit" size="lg" squared>
                  <template v-if="isUpdate">แก้ไข</template>
                  <template v-if="!isUpdate">ยืนยัน</template>
                </b-button>
              </b-card-text>
            </b-form>
          </b-card-body>
        </b-card>
        <b-row v-html="footerHTML"></b-row>
        <!-- <br> -->
        <!-- <b-button variant="primary" pill @click="loginUser" block>Already have an account? <strong>Log in</strong></b-button> -->
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import axios from 'axios' // api
export default {
  name: 'Register',
  beforeCreate () {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
    // document.body.className = 'login';
  },
  created () {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
  },
  async mounted () {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด 
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    // this.getIPClient()

    this.getDataUser()
  },    
  computed: {
    telState () {
      return this.form.telephone.length >= 9 ? true : false
    }
  },
  data () {
    return {
      dataReady: true,
      confirmRequest: '1',
      accept: false,
      isUpdate: false,
      form: {
        department: '',
        displayname_en: '',
        displayname_th: '',
        faculty: '',
        id_card: '',
        prefix_th: '',
        username: '',
        telephone: ''
      }
    }
  },
  methods: {
    getDataUser () {
      let dt = this.getDataSessionUser()
      if (dt) {
        // console.log('getDataUser', dt)
        // this.getDataPrivate(dt)

        // this.form.department = dt.department
        // this.form.displayname_en = dt.displayname_en
        // this.form.displayname_th = dt.displayname_th
        // this.form.faculty = dt.faculty
        // this.form.id_card = dt.idCard
        // this.form.prefix_th = dt.prefixname
        // this.form.username = dt.username
        this.form.displayname_en = dt.displayname_en
        this.form.department = dt.department
        this.form.faculty = dt.faculty
        this.getDataPrivate(dt)
      } else {
        this.$router.push('/')
      }
    },
    getDataPrivate (data) {
      this.dataReady = false
      let dt = { username: data.username }
      let hk = this.getHashKey(dt)
      let header = {
        'application-key': this.headerAPI['application-key'] + hk
      }
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://restapi.tu.ac.th/tu_covid_api/Refund/check_data?username=' +
          // 'https://restapi.tu.ac.th/api/company/auth/Profile/info?username=' +
          dt.username,
          {
            headers: header
          }
        )
        .then((response) => {
          // console.log('getDataPrivate', response.data)
          let rs = response.data
          let dt_check_user = rs.objStudent

          if (rs.status === true) {
            this.isUpdate = rs.status
            this.confirmRequest = rs.statusConfirm
            this.form.telephone = rs.telephone
          }

          this.form.displayname_th = dt_check_user.THAINAME
          this.form.prefix_th = dt_check_user.THAITITLE
          this.form.username = dt_check_user.STUDENTID
          this.form.id_card = dt_check_user.TMPCITIZENID

          // this.form.displayname_th = rs.displayname_th
          // this.form.id_card = rs.id_card
          // this.form.prefix_th = rs.prefix_th
          // this.form.username = rs.username
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // console.log('getDataUser error:', error)
          this.$swal("ผิดพลาด","ไม่สามารถดึงข้อมูลนักศึกษาได้","error")
          // this.$swal("ผิดพลาด","เนื่องจากมีผู้ใช้งานเป็นจำนวนมาก กรุณารอประมาณ 10 นาทีแล้วจึงทำรายการใหม่อีกครั้ง","error")
          this.dataReady = true
        })
    },
    onSubmit (event) {
      let chkData = true
      event.preventDefault()

      if (this.confirmRequest) {
      } else {
        this.$swal("ผิดพลาด","กรุณาเลือกความประสงค์ของท่าน","error")
        chkData = false
      }

      if (this.form.telephone) {
      } else {
        this.$swal("ผิดพลาด","กรุณากรอกเบอร์โทรติดต่อกลับ","error")
        chkData = false
      }

      // if (this.form.email) {
      // } else {
      //   this.$swal("ผิดพลาด","กรุณากรอกอีเมลติดต่อกลับ","error")
      //   chkData = false
      // }

      if (chkData) {
        let textConfirm = ''
        if(this.confirmRequest === '1') {
          textConfirm = '<b class="text-success" style=" font-size: 1.2rem; ">ขอยืนยันสิทธิรับส่วนลดค่าเล่าเรียนและค่าธรรมเนียมการศึกษา</b>' 
        }
        if(this.confirmRequest === '2') {
          textConfirm = '<b class="text-danger" style=" font-size: 1.2rem; ">ไม่ขอรับส่วนลดค่าเล่าเรียนและค่าธรรมเนียมการศึกษา</b>' 
        }
        // this.registerClaim()
        let timeNow = new Date().getTime()
        // if (timeNow > 1632070800000 && timeNow < 1632675599000) {
          this.$swal({
            title: 'กรุณาตรวจสอบก่อนยืนยันสิทธิ์',
            html: "ท่านทำการเลือก " + textConfirm + " ยืนยันว่าถูกต้องใช่หรือไม่",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'ยืนยันสิทธิ์ที่เลือก',
            cancelButtonText: 'ยกเลิก กลับไปเลือกใหม่'
            // reverseButtons: true
          }).then((result) => {
            if (result.isConfirmed) {
              this.checkData()
            } else {
              this.$swal(
                'ยกเลิก',
                'กรุณาเลือกความประสงค์ของท่านใหม่อีกครั้ง',
                'info'
              )
            }
          })
        // } else {
        //   this.$swal({
        //     titleText: "",
        //     html: 'เปิดระบบขอเลือกรับสิทธิ์ หรือแก้ไขการเลือกรับสิทธิ์<br>ภายใน <b>วันที่ 20 กันยายน 2564 เวลา 00:00 น.</b><br>ถึง <b>วันที่ 27 กันยายน 2564 เวลา 23:59 น.</b> เท่านั้น',
        //     icon: "info"
        //   })
          
        //   this.$router.push('/')
        // }
      }
    },
    async registerClaim () {
      // console.log('registerClaim Form', this.form)
      this.dataReady = false

      let dt = {
        username: this.form.username,
        cid: this.form.id_card,
        telephone: this.form.telephone,
        status: this.confirmRequest
      }

      let hk = this.getHashKey(dt)

      let header = {
        'application-key': this.headerAPI['application-key'] + hk
      }

      // 
      
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://restapi.tu.ac.th/tu_covid_api/Refund/refund",
          dt,
          {
            headers: header
          }
        )
        .then(async (response) => {
          // console.log('registerClaim', response)
          let rs = response.data
          if (rs.status === true) {
            this.$session.set('cft', dt.status)
            this.$swal({
              titleText: "สำเร็จ",
              html: "ลงทะเบียนตอบรับเรื่อง สิทธิ์ลดหย่อน เรียบร้อย",
              icon: "success"
            })
              .then((result) => {
                this.$router.push('/Certificate')
              })
          } else {
            // if (rs.message === 'Username invalid') {
            //   this.$swal("ผิดพลาด","รหัสนักศึกษาของท่านไม่ได้สิทธิ์ลดหย่อน","error")
            //   this.$router.push('/')
            // } else {
            this.$swal("ผิดพลาด","ไม่สามารถลงทะเบียนตอบรับเรื่อง สิทธิ์ลดหย่อน ได้","error")
            // }
            this.dataReady = true
          }
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal("ผิดพลาด","ไม่สามารถลงทะเบียนขอรับสิทธิ์ได้","error")
          this.dataReady = true
        })
    },
    async updateClaim () {
      // console.log('registerClaim Form', this.form)
      this.dataReady = false

      let dt = {
        username: this.form.username,
        cid: this.form.id_card,
        telephone: this.form.telephone,
        status: this.confirmRequest
      }

      let hk = this.getHashKey(dt)

      let header = {
        'application-key': this.headerAPI['application-key'] + hk
      }

      // 
      
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://restapi.tu.ac.th/tu_covid_api/Refund/refund_update_status",
          dt,
          {
            headers: header
          }
        )
        .then(async (response) => {
          // console.log('registerClaim', response)
          let rs = response.data
          if (rs.status === true) {
            this.$session.set('cft', dt.status)
            this.$swal({
              titleText: "สำเร็จ",
              html: "แก้ไขการตอบรับเรื่อง สิทธิ์ลดหย่อน เรียบร้อย",
              icon: "success"
            })
              .then((result) => {
                this.$router.push('/Certificate')
              })
          } else {
            this.$swal("ผิดพลาด","ไม่สามารถแก้ไขการตอบรับเรื่อง สิทธิ์ลดหย่อน ได้","error")
            this.dataReady = true
          }
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal("ผิดพลาด","ไม่สามารถแก้ไขการขอรับสิทธิ์ได้","error")
          this.dataReady = true
        })
    },
    checkData () {
      if (this.isUpdate === true) {
        // มีข้อมูล
        this.$swal({
          titleText: "",
          html: 'เปิดระบบขอเลือกรับสิทธิ์ หรือแก้ไขการเลือกรับสิทธิ์<br>ภายใน <b>วันที่ 20 กันยายน 2564 เวลา 00:00 น.</b><br>ถึง <b>วันที่ 27 กันยายน 2564 เวลา 23:59 น.</b> เท่านั้น',
          icon: "info"
        })

        // this.updateClaim()
        // this.$swal("ตรวจพบว่าท่านทำรายการไปแล้ว","กรณีที่ยืนยันขอรับสิทธิ์แล้วต้องการทำรายการซ้ำอีกครั้ง ขอให้นักศึกษาแนบภาพใบยืนยันสิทธิ์เดิมพร้อมแจ้งความจำนงค์มาที่ Line ICT TU Helpdesk","info")
        // .then((result) => {
        //     this.$session.set('cft', rs.statusConfirm)
        //     this.$router.push('/Certificate')
        //   })
      } else {
        // ไม่มีข้อมูล
        this.registerClaim()
      }
    },
    loginUser () {
      this.$router.push('/')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-login{
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/Refund/RequestDetail.vue